import './media-hub.css';

import base from '../base/base';
import header from '../base/header';

import TopVideoPlayer from '../../components/platformPlayer/TopVideoPlayer';
import MediaCarousel from '../../components/mediaCarousel/MediaCarousel';

new TopVideoPlayer();

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 200;